







import { Vue } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import DocumentGrid from "@/components/document/document-grid.vue";
import {DataSource} from "@/utils/grid/datasource";
import {documentApiProvider} from "@/providers/document-api-provider";

@Component({
  components: { DocumentGrid },
})
export default class GedPage extends Vue {
  datasource: DataSource;

  breadcrumbs = [{ text: this.$t("app.title") }, { text: `${this.$t("ged.title")}` }];

  async beforeMount() {
    this.$route.meta.title = this.$t("ged.title");
    this.datasource = DataSource.from(documentApiProvider)
  }
}
